<template>
  <div class="position-box contractTranasction">
    <div class="scroll-box">
      <div class="kline-head">
        <div class="kline-left">
          <img class="back" src="@/assets/icon_back.png" @click="back" alt="back">
          <img class="btn-alert" src="@/assets/trend_tabulate.png" alt="" @click="leftShow">
          <div class="t1" :data="currency">{{ currency }}/USDC</div>
        </div>
        <div class="kline-right">
          <img class="btn btn-collect" src="@/assets/Position-list.png" alt="" @click="link">
        </div>
      </div>
      <div class="info-box">
        <div class="info-head">
          <ul class="info-left">
            <li class="price" :class="[Number(updown) < 0 ? 'red' : '']">{{ newprice | toFixed4 }}</li>
            <li class="t1"><span :class="[Number(updown) < 0 ? 'red' : '']">{{ updown | toFixed2 }}%</span></li>
          </ul>
          <ul class="info-right">
            <li class="item">
              <div>{{ $t('kxt.gao') }}</div>
              <div class="num">{{ maxprice | toFixed4 }}</div>
            </li>
            <li class="item">
              <div>{{ $t('kxt.di') }}</div>
              <div class="num">{{ minprice | toFixed4 }}</div>
            </li>
            <li class="item">
              <div>24H</div>
              <div class="num">{{ dayvom | toFixed4 }}</div>
            </li>
          </ul>
        </div>
        <div class="info-foot">
          <div class="item-box">
            <div class="item time" :class="{ active: tabIdx == 0 }" @click="tab(0, '1min')" data-val="1"
              data-type="1min" data-chartType="1">1<span>{{ $t('kxt.fz') }}</span></div>
            <div class="item time" :class="{ active: tabIdx == 1 }" @click="tab(1, '15min')" data-val="15"
              data-type="15min" data-chartType="1">15<span>{{ $t('kxt.fz') }}</span></div>
            <div class="item time" :class="{ active: tabIdx == 2 }" @click="tab(2, '60min')" data-val="60"
              data-type="60min" data-chartType="1">1<span>{{ $t('kxt.xs') }}</span></div>

            <div class="item time" :class="{ active: tabIdx == 3 }" @click="tab(3, '1day')" data-val="1D"
              data-type="1day" data-chartType="1">1<span>{{ $t('kxt.tian') }}</span></div>
            <div class="item more" :class="{ moreActive: isMore }" @click="moreClick">
              <div>{{ $t('kxt.gd') }}</div>
              <img class="down" src="@/assets/trend_more_gray.png" v-show="!isMore" alt="">
              <img class="down" src="@/assets/trend_more_light.png" v-show="isMore" alt="">
            </div>
            <!-- 更多框 -->
            <div class="alert-sdt-box" v-show="isMore">
              <ul class="alert-sdt-ul">
                <li class="alert-more-list">
                  <div class="text" :class="{ active: timeIdx == 0 }" data-val="5" data-type="5min" data-chartType="1"
                    @click="timeClick(0, '5min')">5<span>{{ $t('kxt.fz') }}</span></div>
                  <div class="text" :class="{ active: timeIdx == 1 }" data-val="30" data-type="30min" data-chartType="1"
                    @click="timeClick(1, '30min')">30<span>{{ $t('kxt.fz') }}</span></div>
                  <div class="text" :class="{ active: timeIdx == 2 }" data-val="1W" data-type="1week" data-chartType="1"
                    @click="timeClick(2, '1week')">1<span>{{ $t('kxt.zhou') }}</span></div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- k线图 -->
      <div id="charts" class="kline-box"></div>
      <div class="cont-box">
        <ul class="tab-box">
          <li class="tab" :class="{ active: footIdx == 0 }" @click="footTab(0)">{{ $t('kxt.wtgd') }}</li>
          <li class="tab" :class="{ active: footIdx == 1 }" @click="footTab(1)">{{ $t('kxt.cj') }}</li>
          <li class="tab" :class="{ active: footIdx == 2 }" @click="footTab(2)">{{ $t('kxt.jj') }}</li>
        </ul>
        <!-- 委托挂单 -->
        <div class="item0-box" v-show="footIdx == 0">
          <ul class="table-head">
            <li class="th w2">{{ $t('kxt.slb') }}</li>
            <li class="th w7">{{ $t('kxt.jg') }}</li>
            <li class="th w5">{{ $t('kxt.slb') }}</li>
          </ul>
          <div class="ul-box">
            <div class="list list-left">
              <ul class="ul">
                <li class="item" v-for="(item, index) in buyArr" :key="index">
                  <div class="w2">{{ item[1] | toFixed4 }}</div>
                  <div class="w3">{{ item[0] | toFixed4 }}</div>
                  <div class="scroll"
                    :style="{ 'width': (((item[0] * item[1]) / 8000) > 100 ? '100%' : ((item[0] * item[1]) / 8000) + Math.random() * 15 + '%') }">
                  </div>
                </li>
              </ul>

            </div>
            <div class="list list-right">
              <ul class="ul">
                <li class="item" v-for="(item, index) in sellArr" :key="index">
                  <div class="w4">{{ item[0] | toFixed4 }}</div>
                  <div class="w5">{{ item[1] | toFixed4 }}</div>
                  <div class="scroll2"
                    :style="{ 'width': (((item[0] * item[1]) / 8000) > 100 ? '100%' : ((item[0] * item[1]) / 8000) + Math.random() * 15 + '%') }">
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 成交 -->
        <div class="item1-box" v-show="footIdx == 1">
          <ul class="table-head">
            <li class="th">{{ $t('kxt.sj') }}</li>
            <li class="th">{{ $t('kxt.fx') }}</li>
            <li class="th tc">{{ $t('kxt.jg') }}</li>
            <li class="th tc">{{ $t('kxt.sl') }}</li>
          </ul>
          <ul class="table-body">
            <li class="table-tr" v-for="(item, index) in cjArr" :key="index">
              <div class="td">{{ item.ts | timeTamp }}</div>
              <div class="td mr" :class="{ mc: item.direction == 'sell' }">{{ item.direction }}</div>
              <div class="td tc">{{ item.price | toFixed4 }}</div>
              <div class="td tc">{{ item.amount | toFixed4 }}</div>
            </li>
          </ul>
        </div>
        <!-- 简介 -->
        <div class="item2-box contractTransaction" v-show="footIdx == 2">
          <div class="cont1">{{ message.message }}</div>
          <ul class="ul-box" v-if="lang == 'ar'">
            <li class="list">
              <p class="t2">{{ message.issue_time }}</p>
              <p class="t1">{{ $t('kxt.fhsj') }}</p>
            </li>
            <li class="list">
              <p class="t2">{{ message.issue_number }}</p>
              <p class="t1">{{ $t('kxt.fhsl') }}</p>
            </li>
            <li class="list" v-show="message.white_book">
              <p class="t2"><a :href="message.white_book" style="color: #218adc" target="_blank">{{ $t('kxt.djck')
                  }}</a>
              </p>
              <p class="t1">{{ $t('kxt.bps') }}</p>
            </li>
            <li class="list">
              <p class="t2"><a :href="message.weburl">{{ message.weburl }}</a></p>
              <p class="t1">{{ $t('kxt.gw') }}</p>
            </li>
          </ul>
          <ul class="ul-box" v-else>
            <li class="list">
              <p class="t1">{{ $t('kxt.fhsj') }}</p>
              <p class="t2">{{ message.issue_time }}</p>
            </li>
            <li class="list">
              <p class="t1">{{ $t('kxt.fhsl') }}</p>
              <p class="t2">{{ message.issue_number }}</p>
            </li>
            <li class="list">
              <p class="t1">{{ $t('kxt.bps') }}</p>
              <p class="t2" v-show="message.white_book"><a :href="message.white_book" style="color: #218adc"
                  target="_blank">{{ $t('kxt.djck') }}</a></p>
            </li>
            <li class="list">
              <p class="t1">{{ $t('kxt.gw') }}</p>
              <p class="t2"><a :href="message.weburl">{{ message.weburl }}</a></p>
            </li>
          </ul>
        </div>
        <!-- 暂无数据 -->
        <no-data v-show="isNoData"></no-data>
      </div>
    </div>
    <div class="mask" v-show="isMask" @click="cancle"></div>
    <!-- 左侧弹框  -->
    <div class="alert-left" v-show="isLeftShow">
      <ul class="tab-box">
        <li class="tab" :class="{ active: tabLeftIdx == 0 }" @click="tabLeft(0)">{{ $t('bbjy.zx') }}</li>
        <li class="tab" :class="{ active: tabLeftIdx == 1 }" @click="tabLeft(1)">USDC</li>
      </ul>
      <ul class="ul-box">
        <li class="list" :class="{ active: item.symbol == symbol }" v-for="(item, index) in leftData" :key="item.id"
          @click="leftClick(index, item.name, item.symbol, item.icon, item.type)">
          <div class="list-box">
            <div class="t1">{{ item.name | rewriteName }}/<span>USDC</span></div>
            <div class="price" :class="{ green: item.change > 0 }">{{ item.new_price | toFixed4 }}</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="btn-box">
      <template v-if="newprice">
        <button class="btn btn-buy" type="button" @click="buy($t('jghy.mz'), 1)">{{ $t('jghy.mz') }}</button>
        <button class="btn btn-sell" type="button" @click="buy($t('jghy.md'), 2)">{{ $t('jghy.md') }}</button>
      </template>
      <template v-else>
        <button class="btn btn-buy" type="button" style="background: #666">{{ $t('jghy.mz') }}</button>
        <button class="btn btn-sell" type="button" style="background: #666">{{ $t('jghy.md') }}</button>
      </template>
    </div>
    <!-- 弹窗 -->
    <div class="mask" v-show="isJgShow"></div>
    <!-- 订单确认 -->
    <div class="alert-wrap" v-show="isJgShow">
      <div class="alert-box">
        <div class="alert-head order-head">
          <div class="title">{{ currency }} {{ $t('tipsNew.jiaoge') }}</div>
          <div><img class="close" src="@/assets/close.png" alt="" @click="close"></div>
        </div>
        <diV class="order-item1">
          <div class="box-lt">
            <img class="icon" :src="curCoin" alt="">
            <div>
              <p class="t1">{{ currency }}</p>
              <p class="t2">{{ $t('bbjy.mai') }} <span class="green" v-if="fx == 1">{{ $t('tipsNew.zhang')
                  }}</span><span class="red" v-else>{{ $t('tipsNew.die') }}</span></p>
            </div>
          </div>
          <div class="box-rt">
            <div class="time-box">
              <img class="time-icon" src="@/assets/shijian.png" alt="">
              <div class="time">
                <span v-if="timeObj.time == 3600">1 H</span>
                <span v-else-if="timeObj.time == 43200">12 H</span>
                <span v-else-if="timeObj.time == 86400">24 H</span>
                <span v-else>{{ timeObj.time / 60 }} min</span>
              </div>
            </div>
            <div class="money"><span>{{ $t('jghy.sy') }} </span>{{ timeObj.rate }}%</div>
          </div>
        </diV>
        <div class="alert-tips">{{ $t('jghy.jgsj') }}</div>
        <div class="order-item2">
          <div class="time-box" @click="showJgTime">
            <img class="icon" src="@/assets/shijian.png" alt="">
            <div class="time">
              <span v-if="timeObj.time == 3600">1 H</span>
              <span v-else-if="timeObj.time == 43200">12 H</span>
              <span v-else-if="timeObj.time == 86400">24 H</span>
              <span v-else>{{ timeObj.time / 60 }} min</span>
            </div>
            <img class="arrow" src="@/assets/jiantouxia.png" alt="">
          </div>
          <div class="fx-box" v-if="fx == 1">
            <div class="bg-box">
              <img class="bg-icon" src="@/assets/coin_left_green.png" alt="">
              <div class="text">{{ $t('tipsNew.zhang') }}</div>
            </div>
            <div class="bg-box">
              <img class="bg-icon" src="@/assets/coin_right_gray.png" alt="">
              <div class="text">{{ $t('tipsNew.die') }}</div>
            </div>
          </div>
          <div class="fx-box" v-else>
            <div class="bg-box">
              <img class="bg-icon" src="@/assets/coin_left_gray.png" alt="">
              <div class="text">{{ $t('tipsNew.zhang') }}</div>
            </div>
            <div class="bg-box">
              <img class="bg-icon" src="@/assets/coin_right_red.png" alt="">
              <div class="text">{{ $t('tipsNew.die') }}</div>
            </div>
          </div>
        </div>
        <div class="alert-tips">{{ $t('jghy.tzje') }}</div>
        <div class="order-item2">
          <div class="time-box">
            <img class="icon" :src="curCoin" alt="">
            <div class="time">{{ currency }}</div>
          </div>
          <div class="input-box">
            <input class="input number" type="number" v-model="tzmoney" :placeholder="placeholder" @keyup="keyMoney">
          </div>
        </div>
        <div class="trade-wrap">
          <div class="trade-box">
            <div class="text">{{ $t('jghy.kyye') }}</div>
            <div class="text text-center">{{ $t('jghy.sl') }}</div>
            <div class="text text-right">{{ $t('jghy.xj') }}</div>
          </div>
          <div class="trade-box trade-item">
            <div class="text t1"><span v-show="!isKyZcShow" class="money">{{ useBalance }}</span><span
                v-show="isKyZcShow" class="money">******</span><img class="icon" v-show="isKyZcShow"
                src="@/assets/Log-In_close-eyes.png" @click="change" alt="" /><img class="icon"
                src="@/assets/Log-In_eyes.png" v-show="!isKyZcShow" @click="change" alt=""></div>
            <div class="text t2 text-center">{{ rate }}%</div>
            <div class="text t3 text-right">{{ newprice | toFixed4 }}</div>
          </div>
        </div>
        <div class="alert-btn-box">
          <button id="order" type="button" class="btn order" @click="order(1)">{{ $t('jghy.qrxd') }}</button>
        </div>
      </div>
    </div>
    <div class="alert-wrap" v-show="isJgTime">
      <div class="alert-box">
        <div class="alert-head">
          <div class="title">{{ filterName(detailData.currency_name) }}</div>
          <div><img class="close" src="@/assets/close.png" alt="" @click="close"></div>
        </div>
        <!-- 结果 -->
        <div class="price-box" v-show="is_close">
          <div v-if="!isJsDOwnTime" style="color: #4458ed; font-size: 15px;">{{ this.$t('tipsNew.ddz') }}</div>
          <div v-else><span>{{ this.$t('jghy.yk') }}</span> <span class="num"
              v-if="parseFloat(detailData.profit_loss) == 0">0</span><span class="num" v-else
              :class="{ red: parseFloat(detailData.profit_loss) < 0 }">{{ detailData.profit_loss | toFixed4 }}</span>
            USDC
          </div>
        </div>
        <!-- 结果 -->
        <div class="circle-box" v-show="!is_close">
          <div id="times" class="text">{{ detailData.cut_time }} S</div>
          <svg class="circle" width="84" height="84">
            <circle cx="40" cy="40" r="36" fill="transparent" stroke="#4458ed" stroke-width="6"></circle>
            <circle id="circle" class="alert-sec-circle" cx="40" cy="40" r="36" fill="transparent" stroke="#e9f0ff"
              stroke-width="8" transform="rotate(-90 40 40)"></circle>
          </svg>
        </div>

        <ul class="item-box">
          <li class="item" v-show="is_close">
            <div>{{ $t('jghy.jsj') }}</div>
            <div class="t1">{{ detailData.close_price }}</div>
          </li>
          <li class="item" v-show="!is_close">
            <div>{{ $t('jghy.gmj') }}</div>
            <div class="t1">{{ detailData.price }}</div>
          </li>
          <li class="item" v-show="!is_close">
            <div>{{ $t('jghy.xj') }}</div>
            <div class="t2 price">{{ newprice | toFixed4 }}</div>
          </li>
          <li class="item">
            <div>{{ $t('jghy.fx') }}</div>
            <div class="t2 price" :class="{ red: detailData.type == 2 }">{{ detailData.type | fx }}</div>
          </li>
          <li class="item">
            <div>{{ $t('jghy.sl') }}</div>
            <div class="t1">{{ detailData.amount }}</div>
          </li>
          <li class="item">
            <div>{{ $t('jghy.jgsj') }}</div>
            <div class="t1" v-if="detailData.cut_time == 86400">24 {{ $t('tipsNew.xs') }}</div>
            <div class="t1" v-else>{{ detailData.cut_time }} S</div>
          </li>
          <li class="item" v-show="is_close">
            <div>{{ $t('jghy.dqye') }}</div>
            <div class="t1">{{ detailData.hy_usdt }}</div>
          </li>
        </ul>
        <div class="alert-btn-box">
          <button type="button" class="btn close" @click="close">{{ $t('jghy.gb') }}</button>
          <button type="button" class="btn order" @click="agin">{{ $t('jghy.jxxd') }}</button>
        </div>
      </div>
    </div>
    <!-- 交割时间 -->
    <div class="alert-time-box" v-show="isShow">
      <div class="alert-item" :class="{ active: cutTimeIdx == index }" v-for="(item, index) in cutTimeList"
        :key="item.id" @click="timeSelect(index, item)">
        <span v-if="item.time == 3600">1 H</span>
        <span v-else-if="item.time == 43200">12 H</span>
        <span v-else-if="item.time == 86400">24 H</span>
        <span v-else>{{ item.time / 60 }} min</span>
      </div>
      <div class="alert-item btn-cancle" @click="cancle">{{ $t('hyjy.qx') }}</div>
    </div>
    <nav-bar :navName="'contractTransaction'"></nav-bar>
    <loading v-show="isLoad"></loading>
  </div>
</template>

<script>
import noData from '@/components/noData.vue'
import loading from '@/components/loading.vue'
import navBar from '@/components/NavBar.vue'
import echarts from 'echarts'
let that = this;
var myChart;
var socket = {};
socket.bh = true;
export default {
  name: 'contractTransaction',
  data() {
    return {
      theme: false,
      tabIdx: 0,
      footIdx: 0,
      isLoad: false,
      isMore: false,
      isSdt: false,
      websock: null,
      widget: null,
      symbolInfo: null,
      feed: null,
      wsEx: null,
      ws: null,
      isNoData: false,
      message: '',//简介
      leftData: [],
      isMask: false,
      isLeftShow: false,//左侧币种弹窗
      leftIdx: 0,
      tabLeftIdx: 1,
      isCollect: 0,
      lists: [],
      newData: '',
      currency: '',
      symbol: '',
      priceScale: 100000,
      histime: '',
      newprice: '',
      updown: '',
      maxprice: '',
      minprice: '',
      dayvom: '',
      deList: [],
      prevData: [],
      sellArr: [],//右侧前五条数据
      buyArr: [],//左侧后五条数据
      cjArr: [],//成交数据,
      jgIdx: 0,
      timeIdx: 5,
      isJgShow: false,
      isJgTime: false,//交割倒计时
      tzmoney: '',//投资金额
      xianjia: '',//现价
      fxText: '',//方向文本
      fx: 1,
      rate: '',//手续费
      useBalance: '',//可用余额
      orderId: '',
      cutTimeList: [],
      detailData: {
        "profit_loss": 0
      },
      timeObj: {},
      is_close: false,
      timer: null,
      timerTimes: null,
      placeholder: '',
      klineTimer: null,
      orderTimes: null,
      base_auth_status: 0,
      count: 1,
      isSmrz: 0,
      cutTimeIdx: 0,
      currencyList: [],
      klineData: '',
      isKyZcShow: false,
      isShow: false,
      curCoin: require('../assets/BTC.png'),
      lang: 'en',
      ktype: "1min",
      klineDates: [],
      klineDatas: [],
      yAxisData: [],
      volumes: [],
      current: 0,
      dynamicItems: [
        {
          type: "candlestick",
          name: "日K",
          data: [],
          itemStyle: {
            color: '#00c483',
            color0: '#d14b65',
            borderColor: '#00c483',
            borderColor0: '#d14b65',
          },
          markPoint: {
            symbol: "rect",
            symbolSize: [-10, 0.5],
            symbolOffset: [5, 0],
            itemStyle: {
              color: "rgba(255,255,255,.87)",
            },
            label: {
              // show: false,
              color: "rgba(255,255,255,.87)",
              offset: [10, 0],
              fontSize: 10,
              align: "left",
              formatter: function (params) {
                return Number(params.value).toFixed(2);
              },
            },
            data: [
              {
                name: "max",
                type: "max",
                valueDim: "highest",
              },
              {
                name: "min",
                type: "min",
                valueDim: "lowest",
              },
            ],
          },
        },
      ],
      lockReconnect: false, //soket重连
      syTimes: 0, //倒计剩余时间
      isJsDOwnTime: false //结束倒计时
    }
  },
  beforeCreate() {
    that = this;
  },
  created() {
    this.theme = JSON.parse(localStorage.getItem('theme'));
    this.lang = localStorage.getItem('language') || 'en';
    if (this.$route.query.symbol) {
      this.symbol = this.$route.query.symbol;
      this.currency = this.$route.query.symbol.split('/')[0];
    }
    let kyZcShow = localStorage.getItem('kyZcShow');
    if (kyZcShow == null || kyZcShow == 'false') {
      localStorage.setItem('kyZcShow', false);
      this.isKyZcShow = false
    } else {
      localStorage.setItem('kyZcShow', true);
      this.isKyZcShow = true
    }
  },
  mounted() {
    let that = this;
    let params = {
      id: 1,
      type: 1,
      token: '',
      classify: 0,
    }
    this.$ajax.get('/web/getmarketList', { params }).then((res) => {
      let resData = res.data.data;
      if (res.data.code == 1000) {
        setTimeout(() => {
          this.$router.push('/index');
        }, 1000)
        return false
      }
      this.curCoin = resData[0].icon;
      if (that.symbol == '' || that.symbol == null) {
        that.currency = resData[0].currency;
        that.symbol = resData[0].symbol;
        that.getmarketList();
        that.getCollect();//是否收藏
        that.daymarket();
        that.initWebSocket();
        that.getKlineHistory();
        that.getCenterLevel();
        that.getRenzheng();
        that.getCutTimeList();
      } else {
        that.getmarketList();
        that.getCollect();//是否收藏
        that.daymarket();
        that.initWebSocket();
        that.getKlineHistory();
        that.getCenterLevel();
        that.getRenzheng();
        that.getCutTimeList();
      }
    }).catch(function (err) {
      console.log(err)
    })
    myChart = echarts.init(document.getElementById('charts'));
  },
  methods: {
    filterName(name) {
      if (name) {
        const list = name.split('/USD')
        if (list.length > 1) {
          return `${list[0]}/USDC`
        }
        return name
      }
      return ''
    },
    link() {
      this.$router.push('/positionList')
    },
    back() {
      this.$router.push('/index')
    },
    times(timess) {
      var date = new Date((timess));//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + " " + h + m + s;
    },
    getKlineHistory() {
      var that = this;
      var symbol = this.symbol.replace('/', '').toLowerCase();
      let params = {
        symbol: symbol,
        period: that.ktype,
      }
      this.$ajax.get('/web/new_timeshar', { params }).then((res) => {
        if (res.status == 200) {
          if (res.data.data.length > 0) {
            let resData = res.data.data;
            var newArr2 = [];
            var klineHistory = resData;
            klineHistory.forEach((item, i) => {
              if (String(item.Date).length == 10) {
                item.Date = Number(item.Date * 1000);
              } else {
                item.Date = Number(item.Date);
              }
              item.volume = Number(item.Volume);
              item.open = Number(item.Open);
              item.close = Number(item.Close);
              item.high = Number(item.High);
              item.low = Number(item.Low);
              newArr2.push([that.times(item.Date), item.Open, item.Close, item.Low, item.High, item.Volume]);
            });
            newArr2.reverse();
            that.newArr = newArr2;
            that.klineDates = newArr2.map(function (item) {
              return item[0];
            })
            that.klineDatas = newArr2.map(function (item) {
              return [+item[1], +item[2], +item[3], +item[4], +item[5]];
            });
            that.volumes = newArr2.map(function (item, index) {
              return [index, item[5], item[1] > item[2] ? 1 : -1];
            });
            that.yAxisData = newArr2.map(function (item, index) {
              return item[2];
            });
            that.draw();
            that.getKline();
          }
        }
      }).catch(function (err) {
        console.log(err)
      })
    },
    // 获取k线数据,生成k线
    getKline(data) {
      if (data) {
        data = data
      } else {
        data = this.klineDatas;
      }
      var dataNow = this.calculateMA(1, data);
      var dataMA5 = this.calculateMA(5, data);
      var dataMA10 = this.calculateMA(10, data);
      var dataMA30 = this.calculateMA(30, data);
      var volumeMA5 = this.calculateMA(5, this.volumes);
      var volumeMA10 = this.calculateMA(10, this.volumes);
      var option = {
        grid: [
          {
            right: 60,
          },
          {
            right: 60,
          },
        ],
        xAxis: [
          {
            data: this.klineDates
          },
          {
            data: this.klineDates
          },
        ],
        series: [
          {
            name: '日K',
            data: this.current === -1 ? dataNow : data,
          },
          {
            name: 'MA5',
            data: dataMA5
          },
          {
            name: 'MA10',
            data: dataMA10
          },
          {
            name: 'MA30',
            data: dataMA30
          },
          {
            name: 'Volume',
            data: this.volumes
          },
          {
            name: 'VolumeMA5',
            data: volumeMA5
          },
          {
            name: 'VolumeMA10',
            data: volumeMA10
          },
        ]
      }
      option && myChart.setOption(option);
    },
    getTime(times, type) {
      let time = times[0];
      let timeLength = String(time).length;
      let timeStr = null;
      if (timeLength === 10) {
        timeStr = new Date(time * 1000);
      } else if (timeLength === 13) {
        timeStr = new Date(time * 1);
      } else if (timeLength === 19) {
        timeStr = new Date(time);
      }
      let year = timeStr.getFullYear();
      let month = timeStr.getMonth() + 1;
      let day = timeStr.getDate();
      let hour = timeStr.getHours();
      let minute = timeStr.getMinutes();
      let second = timeStr.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      if (type === 1) {
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      } else if (type === 2) {
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      }
      return `${year}-${month}-${day}`;
    },
    // 列表条数不足补全
    addItem(list, type) {
      // type: 1开头加，2末尾加
      list = list || [];
      let len = 20 - list.length;
      if (len > 0) {
        for (let i = 0; i < len; i++) {
          if (type == 1) {
            list.unshift({})
          } else {
            list.push({})
          }
        }
      }
      return list;
    },
    formatterNum(value, precision) {
      let reg = new RegExp('^\\d+(?:\\.\\d{0,' + precision + '})?')
      return value.toString().match(reg)
    },
    // 计算MA
    calculateMA(dayCount, data) {
      var result = [];
      for (var i = 0, len = data.length; i < len; i++) {
        if (i < dayCount) {
          result.push('-');
          continue;
        }
        var sum = 0;
        for (var j = 0; j < dayCount; j++) {
          sum += data[i - j][1];
        }
        result.push((sum / dayCount).toFixed(6));
      }
      return result;
    },
    // 绘制(配置项)
    draw() {
      let that = this;
      var upColor = "#00c483";
      var downColor = "#d14b65";
      var colorList = [
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#749f83",
        "#ca8622",
        "#bda29a",
        "#6e7074",
        "#546570",
        "#c4ccd3",
      ];
      var labelFont = "bold 12px Sans-serif";
      var bgColor = 'transparent';
      var option = {
        backgroundColor: bgColor,
        title: {
          show: false,
        },
        legend: {
          show: false,
        },
        visualMap: {
          show: false,
          seriesIndex: 4,
          dimension: 2,
          pieces: [
            {
              value: 1,
              color: downColor,
            },
            {
              value: -1,
              color: upColor,
            },
          ],
        },
        grid: [
          {
            top: "5%",
            left: 30,
            right: 30,
            height: "70%",
          },
          {
            top: "80%",
            left: 30,
            right: 30,
            height: "16%",
          },
        ],
        barWidth: 3,
        axisPointer: {
          //坐标轴指示器配置项
          link: {
            xAxisIndex: "all",
          },
          type: 'cross',
          label: {
            backgroundColor: "#0d1723",
            color: "#fff",
            borderColor: "rgb(99, 117, 139)",
            borderWidth: 1,
            borderRadius: 2,
            fontSize: 10,
          },
        },
        xAxis: [
          {
            type: "category", //坐标轴类型。(value:数值轴，适用于连续数据。,category:类目轴，适用于离散的类目数据,time: 时间轴，适用于连续的时序数据,log:对数轴。适用于对数数据)
            data: [], //类目数据，在类目轴（type: 'category'）中有效。
            scale: true,
            boundaryGap: false, //坐标轴两边留白策略，类目轴和非类目轴的设置和表现不一样。
            axisLine: {
              show: false,
            }, //坐标轴轴线相关设置
            axisTick: {
              show: false,
            }, //坐标轴刻度相关设置。
            axisLabel: {
              show: false,
            }, //坐标轴刻度标签的相关设置。
            splitLine: {
              show: false,
              lineStyle: {
                color: "rgba(255,255,255, 0.1)",
              },
            }, //坐标轴在 grid 区域中的分隔线。
            min: "dataMin", //坐标轴刻度最小值。可以设置成特殊值 'dataMin'，此时取数据在该轴上的最小值作为最小刻度。
            max: "dataMax", //坐标轴刻度最大值。可以设置成特殊值 'dataMax'，此时取数据在该轴上的最大值作为最大刻度。
            axisPointer: {
              snap: true
            },
          },
          {
            type: "category",
            gridIndex: 1, //x 轴所在的 grid 的索引，默认位于第一个 grid。
            data: [], //类目数据，在类目轴（type: 'category'）中有效。
            scale: true,
            boundaryGap: false, //坐标轴两边留白策略，类目轴和非类目轴的设置和表现不一样。
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(255,255,255,1)",
                width: 1,
              },
            }, //坐标轴轴线相关设置
            axisTick: {
              show: false,
            }, //坐标轴刻度相关设置。
            axisLabel: {
              //坐标轴刻度标签的相关设置。
              show: true,
              margin: 6,
              fontSize: 10,
              color: "rgba(99, 117, 139, 1.0)",
              formatter: function (value) {
                if (that.current !== 7 && that.current !== 8) {
                  return value;
                }
                return echarts.format.formatTime("MM-dd", value);
              },
            },
            splitNumber: 20,
            splitLine: {
              show: false,
              lineStyle: {
                color: "rgba(255,255,255, 0.1)",
              },
            }, //坐标轴在 grid 区域中的分隔线。
            min: "dataMin", //坐标轴刻度最小值。可以设置成特殊值 'dataMin'，此时取数据在该轴上的最小值作为最小刻度。
            max: "dataMax", //坐标轴刻度最大值。可以设置成特殊值 'dataMax'，此时取数据在该轴上的最大值作为最大刻度。
            // axisPointer: { show: true, type: 'none', label: { show: false }},
          },
        ],
        yAxis: [
          {
            type: "value", //坐标轴类型。(value:数值轴，适用于连续数据。,category:类目轴，适用于离散的类目数据,time: 时间轴，适用于连续的时序数据,log:对数轴。适用于对数数据)
            position: "right", //y 轴的位置。'left','right'
            scale: true, //是否是脱离 0 值比例。设置成 true 后坐标刻度不会强制包含零刻度。在双数值轴的散点图中比较有用。(在设置 min 和 max 之后该配置项无效。)
            axisLine: {
              show: true,
            }, //坐标轴轴线相关设置。
            offset: 50,
            axisTick: {
              show: true,
              inside: true,
            }, //坐标轴刻度相关设置。
            axisLabel: {
              //坐标轴刻度标签的相关设置。
              show: true,
              color: "rgba(99, 117, 139, 1.0)",
              inside: true,
              fontSize: 10,
              formatter: function (value) {
                return Number(value).toFixed(4);
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "rgba(255,255,255, 0.1)",
              },
            }, //坐标轴在 grid 区域中的分隔线。
          },
          {
            type: "value",
            position: "right",
            scale: true,
            gridIndex: 1,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],

        animation: true, //是否开启动画。
        color: colorList,
        tooltip: {
          show: true, //是否显示提示框组件，包括提示框浮层和 axisPointer。
          trigger: "axis", //触发类型。item,axis,none
          formatter(params) {
            let tooltip = "";
            let time = "",
              open = 0,
              high = 0,
              low = 0,
              close = 0,
              amount = 0;
            for (var i = 0; i < params.length; i++) {
              if (params[i].seriesName === "日K") {
                time = params[i].name; parseInt
                let oneItem = {}
                if (that.current === -1) {
                  oneItem = that.newArr.find(e => that.getTime(e, 1) === params[i].axisValue);
                }
                open =
                  params[i].data.length > 1
                    ? Number(that.formatterNum(that.current === -1 ? oneItem[1] : params[i].data[1], 5))
                    : 0;
                close =
                  params[i].data.length > 1
                    ? Number(that.formatterNum(that.current === -1 ? oneItem[2] : params[i].data[2], 5))
                    : 0;
                low =
                  params[i].data.length > 1
                    ? Number(that.formatterNum(that.current === -1 ? oneItem[3] : params[i].data[3], 5))
                    : 0;
                high =
                  params[i].data.length > 1
                    ? Number(that.formatterNum(that.current === -1 ? oneItem[4] : params[i].data[4], 5))
                    : 0;
                amount =
                  params[i].data.length > 1
                    ? Number(that.formatterNum(that.current === -1 ? oneItem[5] : params[i].data[5], 5))
                    : 0;
                tooltip =
                  '<div class="charts-tooltip">' +
                  '<div class="charts-tooltip-row"><div class="ctr-label">' +
                  "Time" +
                  '</div><div class="ctr-value">' +
                  time +
                  "</div></div>" +
                  '<div class="charts-tooltip-row"><div class="ctr-label">' +
                  "Open" +
                  '</div><div class="ctr-value">' +
                  open +
                  "</div></div>" +
                  '<div class="charts-tooltip-row"><div class="ctr-label">' +
                  "High" +
                  '</div><div class="ctr-value">' +
                  high +
                  "</div></div>" +
                  '<div class="charts-tooltip-row"><div class="ctr-label">' +
                  "Low" +
                  '</div><div class="ctr-value">' +
                  low +
                  "</div></div>" +
                  '<div class="charts-tooltip-row"><div class="ctr-label">' +
                  "Close" +
                  '</div><div class="ctr-value">' +
                  close +
                  "</div></div>" +
                  '<div class="charts-tooltip-row"><div class="ctr-label">' +
                  "Vol" +
                  '</div><div class="ctr-value">' +
                  amount +
                  "</div></div></div>";
              }
              if (params[i].seriesName === "MA5") {
                that.MA5 =
                  params[i].data !== "NAN"
                    ? Number(that.formatterNum(params[i].data, 6))
                    : 0;
              }
              if (params[i].seriesName === "MA10") {
                that.MA10 =
                  params[i].data !== "NAN"
                    ? Number(that.formatterNum(params[i].data, 6))
                    : 0;
              }
              if (params[i].seriesName === "MA30") {
                that.MA30 =
                  params[i].data !== "NAN"
                    ? Number(that.formatterNum(params[i].data, 6))
                    : 0;
              }
              if (params[i].seriesName === "VolumeMA5") {
                that.volMA5 =
                  params[i].data !== "NAN"
                    ? Number(that.formatterNum(params[i].data, 2))
                    : 0;
              }
              if (params[i].seriesName === "VolumeMA10") {
                that.volMA10 =
                  params[i].data !== "NAN"
                    ? Number(that.formatterNum(params[i].data, 2))
                    : 0;
              }
            }
            return tooltip;
          },
          triggerOn: "click", //提示框触发的条件 'mousemove','click','mousemove|click','none'
          textStyle: {
            fontSize: 10,
          }, //提示框浮层的文本样式
          backgroundColor: "rgba(30,42,66,0.8);", //提示框浮层的背景颜色。
          borderColor: "#2f3a56", //提示框浮层的边框颜色。
          borderWidth: 2,
          position: function (pos, params, el, elRect, size) {
            //提示框浮层的位置，默认不设置时位置会跟随鼠标的位置。
            var obj = {
              top: 20,
            };
            obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 10;
            return obj;
          },
          axisPointer: {
            //坐标轴指示器配置项。
            label: {
              color: "rgba(255,255,255,.87)",
              fontSize: 9,
              backgroundColor: "#020204",
              borderColor: "#9c9fa4",
              shadowBlur: 0,
              borderWidth: 0.5,
              padding: [4, 2, 3, 2],
            },
            animation: false,
            type: "cross",
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(30, 42, 66, 0.1)", // 0% 处的颜色
                  },
                  {
                    offset: 0.7,
                    color: "rgba(30, 42, 66,0.9)", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(30, 42, 66,0.2)", // 100% 处的颜色
                  },
                ],
              },
              width: 1,
              shadowColor: "rgba(30, 42, 66,0.7)",
              shadowBlur: 0,
              shadowOffsetY: 68,
            },
          },
        },

        dataZoom: [
          {
            //用于区域缩放
            type: "inside",
            xAxisIndex: [0, 1],
            realtime: false,
            start: 90,
            end: 100,
          },
        ],
        series: [
          ...this.dynamicItems,
          {
            name: "MA5",
            type: "line",
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#eef4ba" } },
            z: 5,
            tooltip: {
              show: false
            }
          },
          {
            name: "MA10",
            type: "line",
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#83c1c5" } },
            z: 4,
            tooltip: {
              show: false
            }
          },
          {
            name: "MA30",
            type: "line",
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#b39cd8" } },
            z: 3,
            tooltip: {
              show: false
            }
          },
          {
            name: "Volume",
            type: "bar",
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: [],
            tooltip: {
              show: false
            }
          },
          {
            name: "VolumeMA5",
            type: "line",
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#eef4ba" } },
            z: 5,
            tooltip: {
              show: false
            }
          },
          {
            name: "VolumeMA10",
            type: "line",
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#83c1c5" } },
            z: 4,
            tooltip: {
              show: false
            }
          },
        ],
      };
      myChart.setOption(option);
      // 加载上一页数据
      myChart.on('datazoom', function (params) {
        let num = params.batch[0]['start'];
        if (num == 0) {
          console.log('到最左边了')
        }
      })
      window.addEventListener('resize', () => { myChart.resize() })
    },
    daymarket() {
      var that = this;
      let params = {
        symbol: that.currency + 'usdt'
      }
      this.$ajax.get('/web/new_data', { params }).then((res) => {
        let resData = res.data.data;
        var daymarket = JSON.parse(resData.daymarket);
        var market_depth = JSON.parse(resData.market_depth)
        var match_trade = JSON.parse(resData.match_trade)

        that.newprice = daymarket.now_price
        that.maxprice = daymarket.high
        that.minprice = daymarket.low
        that.dayvom = Number(daymarket.volume).toFixed(4);
        that.updown = daymarket.change;

        that.buyArr = market_depth.bids; //买盘
        that.sellArr = market_depth.asks;  //卖盘
        that.cjArr = match_trade.data
      }).catch(function (err) {
        console.log(err)
      })
    },
    jgTab(id) {
      if (id == 1) {
        this.$router.push('/perpetualContract')
      } else if (id == 2) {
        this.$router.push('/currencyTrading')
      }
    },
    change() {
      this.isKyZcShow = !this.isKyZcShow;
      localStorage.setItem('kyZcShow', this.isKyZcShow)
    },
    showJgTime() {
      this.isShow = true;
    },
    keyMoney() {
      this.tzmoney = this.tzmoney.replace(/[^\d.]/g, "");  //仅保留数字和"."
      this.tzmoney = this.tzmoney.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.tzmoney = this.tzmoney.replace(".", "$#*").replace(/\./g, '').replace('$#*', '.');//去除其他"."
      this.tzmoney = this.tzmoney.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
      if (this.tzmoney.indexOf(".") < 0 && this.tzmoney != "") { //首位是0的话去掉
        this.tzmoney = parseFloat(this.tzmoney);
      }
    },
    getCenterLevel() {
      let that = this;
      let params = {
        level: 1
      }
      this.$ajax.get('/web/getCenterLevel', { params }).then((res) => {
        let resData = res.data.data;
        if (res.data.code == 1000) {
          return false
        }
        that.base_auth_status = resData.base_auth_status;
      }).catch(function (err) {
        console.log(err)
      })
    },
    getRenzheng() {
      var that = this;
      this.$ajax.get('/web/has_renzheng', {}).then((res) => {
        let resData = res.data.data;
        if (res.data.code == 1000) {
          return false
        }
        that.isSmrz = resData.level;
      }).catch(function (err) {
        console.log(err)
      })
    },
    initWebSocket() { //初始化weosocket
      const wsuri = this.socket_url;
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() { //连接建立之后执行send方法发送数据
      this.klineTimer = setInterval(() => {
        var msg = { "action": "kline", 'currency': this.currency, "content": '' };
        this.websocketsend(JSON.stringify(msg));
      }, 3000)
    },
    websocketonerror() {//连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) { //数据接收
      let currency = this.currency.toLowerCase();
      if (JSON.parse(e.data).action == "marketprice") {
        let msg = JSON.parse(e.data).content;
        let daymarket = msg[currency.toUpperCase()] || msg[currency.toLowerCase()];
        this.newprice = daymarket.now_price;
        this.maxprice = daymarket.high;
        this.minprice = daymarket.low;
        this.open = daymarket.open;
        this.gp = daymarket.close;
        this.dayvom = Number(daymarket.volume).toFixed(4);
        this.updown = daymarket.change;
        let keyArr = [];
        for (var x in this.currencyList) {
          for (var y in this.leftData) {
            if (!msg[x]) return;
            if (msg[x].currency_name == this.leftData[y].currency_name) {
              this.leftData[y]['new_price'] = msg[x].now_price;
              this.leftData[y]['change'] = msg[x].change;
              keyArr.push(this.leftData[y]);
              break;
            }
          }
        }
        this.leftData = keyArr;
      } else if (JSON.parse(e.data).action == "kline") {
        var ktype = this.ktype;
        this.klineData = '';
        let msg = JSON.parse(e.data).content;
        var klineDatas = msg.kline;
        this.klineData = klineDatas[ktype];
        this.prevData.push(JSON.parse(JSON.stringify(this.klineData)));
        if (this.klineData) return true;
        if (this.klineData.Date > this.prevData[0].Date) {
          this.prevData.push(JSON.parse(JSON.stringify(this.klineData)))
          if (this.prevData.length > 1) this.prevData.shift();
          this.klineDates.push(this.times(this.klineData.Date))
          this.klineDatas.push([this.klineData.Open, this.newprice, this.klineData.Low, this.klineData.High, this.klineData.Volume]);
          this.yAxisData.push(this.klineData.High);
          this.getKline();
        }
        if (this.prevData.length > 1) this.prevData.shift();
      }
    },
    websocketsend(Data) {//数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {  //关闭
      // console.log('断开连接',e);
    },
    getCollect() {
      let that = this;
      let params = {
        id: 1,
        symbol: that.symbol,
        token: ''
      }
      this.$ajax.get('/web/getmarketList', { params }).then((res) => {
        let resData = res.data.data;
        if (res.data.code == 1000) {
          setTimeout(() => {
            this.$router.push('/index');
          }, 1000)
          return false
        }
        that.curCoin = resData[0].icon;
        that.isCollect = resData[0].is_collect;
      }).catch(function (err) {
        console.log(err)
      })
    },
    getCurPrice() {
      let that = this;
      let params = {
        id: 1,
        symbol: that.symbol,
      }
      this.$ajax.get('/web/getmarketList', { params }).then((res) => {
        let resData = res.data.data;
        that.xianjia = resData[0].new_price;
      }).catch(function (err) {
        console.log(err)
      })
    },
    getmarketList() {
      let that = this;
      let params = {
        type: 1,
        id: that.tabLeftIdx,
      }
      that.isLoad = true;
      this.$ajax.get('/web/getmarketList', { params }).then((res) => {
        let resData = res.data.data;
        that.leftData = resData;
        that.currencyList = [];
        for (var curr in resData) {
          that.currencyList[that.leftData[curr].currency_name.toLowerCase()] = [that.leftData[curr].icon, that.leftData[curr].symbol];
        }
        that.isLoad = false;
      }).catch(function (err) {
        console.log(err)
      })
    },
    getMessage() {//获取简介
      let that = this;
      let params = {
        currency: that.currency,
        token: 1
      }
      this.$ajax.get('/web/getCurrencyMessage', { params }).then((res) => {
        let resData = res.data.data;
        if (resData == null) {
          that.message = {};
          that.isNoData = true
        } else {
          that.message = resData;
          that.isNoData = false
        }
      }).catch(function (err) {
        console.log(err)
      })
    },
    collect() {//收藏
      let that = this;
      that.leftData.find((item) => {
        if (item.symbol == that.symbol) {
          var id = item.id;
          let params = {
            id: id
          }
          this.$ajax.post('/web/addCollectCurrenct', params).then((res) => {
            let resData = res.data;
            if (resData.code == 0 || resData.code == 4 || resData.code == 7) {
              that.isCollect = !that.isCollect
            } else {
              this.$toast.center(resData.message);
              return;
            }
          }).catch(function (err) {
            console.log(err)
          })
        }
      })
    },
    leftShow() {
      this.isLeftShow = true;
      this.isMask = true;
    },
    tabLeft(idx) {
      this.leftData = [];
      this.tabLeftIdx = idx;
      this.getmarketList();
    },
    leftClick(idx, name, symbol, coin, type) {//左侧币种选择
      this.leftIdx = idx;
      this.tabIdx = 0;
      this.currency = name;
      this.symbol = symbol;
      this.curCoin = coin;
      this.isLeftShow = false;
      this.isMask = false;
      this.getCollect();
      this.daymarket();
      this.getMessage();
      this.getCutTimeList();
      this.current = 0;
      this.klineDatas = [];
      if (myChart.clear) {
        myChart.clear();
      }
      if (this.current !== -1) {
        var upColor = "#00c483";
        var downColor = "#d14b65";
        this.dynamicItems = [
          {
            type: "candlestick",
            name: "日K",
            data: [],
            itemStyle: {
              color: upColor,
              color0: downColor,
              borderColor: upColor,
              borderColor0: downColor,
            },
            markPoint: {
              symbol: "rect",
              symbolSize: [-10, 0.5],
              symbolOffset: [5, 0],
              itemStyle: {
                color: "rgba(255,255,255,.87)",
              },
              label: {
                color: "rgba(255,255,255,.87)",
                offset: [10, 0],
                fontSize: 10,
                align: "left",
                formatter: function (params) {
                  return Number(params.value).toFixed(2);
                },
              },
              data: [
                {
                  name: "max",
                  type: "max",
                  valueDim: "highest",
                },
                {
                  name: "min",
                  type: "min",
                  valueDim: "lowest",
                },
              ],
            },
          },
        ];
      } else {
        this.dynamicItems = [
          {
            name: "日K",
            type: "line",
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#DCDCDC" } },
            z: 5,
            areaStyle: {
              origin: 'start',
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#ddd' },
                  { offset: 0.5, color: 'pink' },
                  { offset: 1, color: 'red' }
                ]),
              opacity: 0.5
            }
          },
        ];
      }
      this.draw();
      this.websock.onopen();
      this.getKlineHistory();
      this.getKline();
      if (type != 1) {
        this.$router.push({ path: '/preciousMetal', query: { symbol: symbol } })
      }
    },
    buy(obj, fx) {
      this.cutTimeIdx = 0;
      this.isJgShow = true;
      this.fxText = obj;
      this.fx = fx;
      this.getAsset();
    },
    agin() {
      this.isJgTime = false;
      this.isJgShow = true;
      this.is_close = false;
      this.tzmoney = '';
      this.count = 1;
      this.isJsDOwnTime = false;
      $('#order').css('background', '#4458ed');
      clearInterval(this.orderTimes);
      this.orderTimes = null;
      clearInterval(this.timerTimes);
      this.timerTimes = null;
      $('#times').html('');
      document.getElementById("circle").style.strokeDashoffset = 0;
      this.getAsset();
    },
    order() {//下单
      clearInterval(this.orderTimes);
      this.orderTimes = null;
      clearInterval(this.timerTimes);
      this.timerTimes = null;
      $('#times').html('');
      this.detailData = {};
      let that = this;
      let params = {
        currency: this.currency,
        amount: this.tzmoney,
        type: this.fx,
        timeid: this.timeObj.id
      }
      if (this.tzmoney == '' || this.tzmoney == null) {
        this.$toast.center(this.$t('xbsg.qsrsl'));
        return false;
      } else if (parseFloat(this.tzmoney) <= 0) {
        this.$toast.center(this.$t('xbsg.qsrsl'));
        return false;
      } else if (parseFloat(this.tzmoney) < parseFloat(this.timeObj.amount_min)) {
        this.$toast.center(this.$t('tipsNew.min') + this.timeObj.amount_min);
        return false;
      } else if (parseFloat(this.tzmoney) > parseFloat(this.timeObj.amount_max)) {
        this.$toast.center(this.$t('tipsNew.max') + this.timeObj.amount_max);
        return false;
      } else if (parseFloat(this.tzmoney) > parseFloat(this.useBalance)) {
        this.$toast.center(this.$t('tipsNew.yebz'));
        return false;
      }
      if (that.count == 1) {
        that.count = 0;
      } else {
        $('#order').css('background', '#666')
        return false;
      }
      this.$ajax.post('/web/cutBuy', params).then((res) => {
        let resData = res.data;
        if (resData.code == 0 || resData.code == 4 || resData.code == 7) {
          $('#order').css('background', '#666');
          this.$toast.center(resData.message);
          that.orderId = resData.data;
          that.isJgShow = false;
          that.isJgTime = true;
          that.is_close = false;
          that.getCurPrice();
          that.getAsset();
          that.getOrderDetail();
          setTimeout(() => {
            that.count = 1;
            $('#order').css('background', '#4458ed');
          }, 2000)
        } else {
          that.count = 1;
          $('#order').css('background', '#4458ed');
          this.$toast.center(resData.message);
          return;
        }
      }).catch(function (err) {
        console.log(err)
      })
    },
    getOrderDetail() {
      let that = this;
      clearInterval(that.orderTimes);
      that.orderTimes = null;
      clearInterval(that.timerTimes);
      that.timerTimes = null;
      $('#times').html('');
      let params = {
        id: that.orderId
      }
      this.$ajax.get('/web/cutOrder', { params }).then((res) => {
        let resData = res.data.data;
        that.detailData = resData;
        if (that.isJsDOwnTime) {
          if (parseFloat(resData.profit_loss) == 0) {
            setTimeout(() => {
              that.getOrderDetail()
            }, 1000)
          }
        }
        if (that.isJsDOwnTime) return;
        that.downTimes(that.cutTimeList[that.cutTimeIdx].time)
      }).catch(function (err) {
        console.log(err)
      })
    },
    getCutTimeList() {//获取交割时间
      let that = this;
      var params = {
        currency: this.currency
      }
      this.$ajax.get('/web/cutTimeList', { params }).then((res) => {
        let resData = res.data.data;
        that.cutTimeList = resData.list;
        that.timeObj = resData.list[that.cutTimeIdx];
        if (that.lang == 'ar') {
          that.placeholder = that.timeObj.amount_min + ' ' + this.$t('tipsNew.zxtzsl');
        } else {
          that.placeholder = this.$t('tipsNew.zxtzsl') + that.timeObj.amount_min;
        }
        that.rate = resData.rate;
      }).catch(function (err) {
        console.log(err)
      })
    },
    getAsset() {
      let that = this;
      let params = {
        type: 2,
        currency: that.currency
      }
      this.$ajax.get('/web/getInfo', { params }).then((res) => {
        let resData = res.data.data;
        that.useBalance = (Number(resData.wallet.usdt)).toFixed(4);
      }).catch(function (err) {
        console.log(err)
      })
    },
    timeSelect(idx, obj) {
      this.cutTimeIdx = idx;
      this.timeObj = obj;
      this.tzmoney = '';
      this.placeholder = this.$t('tipsNew.zxtzsl') + obj.amount_min;
      this.isShow = false;
    },
    close() {
      this.isJgShow = false;
      this.isJgTime = false;
      this.tzmoney = '';
      this.is_close = false;
      this.isShow = false;
      this.isJsDOwnTime = false;
      this.count = 1;
      this.timeObj = this.cutTimeList[0];
      $('#order').css('background', '#4458ed');
      clearInterval(this.timerTimes);
      this.timerTimes = null;
      clearInterval(this.orderTimes);
      this.orderTimes = null;
      $('#times').html('');
      document.getElementById("circle").style.strokeDashoffset = 0;
    },
    cancle() {
      this.isLeftShow = false;
      this.isMask = false;
      this.isShow = false;
      this.timeObj = this.cutTimeList[0];
    },
    toFixed(v) {
      return parseFloat(v).toFixed(4)
    },
    tab(idx, ktype) {
      this.tabIdx = idx;
      this.isMore = false;
      this.timeIdx = 5;
      this.current = idx;
      this.klineDatas = [];
      this.ktype = ktype;
      if (myChart.clear) {
        myChart.clear();
      }
      if (this.current !== -1) {
        var upColor = "#00c483";
        var downColor = "#d14b65";
        this.dynamicItems = [
          {
            type: "candlestick",
            name: "日K",
            data: [],
            itemStyle: {
              color: upColor,
              color0: downColor,
              borderColor: upColor,
              borderColor0: downColor,
            },
            markPoint: {
              symbol: "rect",
              symbolSize: [-10, 0.5],
              symbolOffset: [5, 0],
              itemStyle: {
                color: "rgba(255,255,255,.87)",
              },
              label: {
                color: "rgba(255,255,255,.87)",
                offset: [10, 0],
                fontSize: 10,
                align: "left",
                formatter: function (params) {
                  return Number(params.value).toFixed(2);
                },
              },
              data: [
                {
                  name: "max",
                  type: "max",
                  valueDim: "highest",
                },
                {
                  name: "min",
                  type: "min",
                  valueDim: "lowest",
                },
              ],
            },
          },
        ];
      } else {
        this.dynamicItems = [
          {
            name: "日K",
            type: "line",
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#DCDCDC" } },
            z: 5,
            areaStyle: {
              origin: 'start',
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#ddd' },
                  { offset: 0.5, color: 'pink' },
                  { offset: 1, color: 'red' }
                ]),
              opacity: 0.5
            }
          },
        ];
      }
      this.draw();
      this.websock.onopen();
      this.getKlineHistory();
      this.getKline();
    },
    moreClick() {
      this.isMore = !this.isMore;
      this.isSdt = false;
    },
    sdtClick() {
      this.isSdt = !this.isSdt;
      this.isMore = false;
    },
    timeClick(idx, ktype) {
      this.timeIdx = idx;
      this.isMore = false;
      this.tabIdx = 5;
      this.ktype = ktype;
      this.current = idx;
      this.klineDatas = [];
      if (myChart.clear) {
        myChart.clear();
      }
      if (this.current !== -1) {
        var upColor = "#00c483";
        var downColor = "#d14b65";
        this.dynamicItems = [
          {
            type: "candlestick",
            name: "日K",
            data: [],
            itemStyle: {
              color: upColor,
              color0: downColor,
              borderColor: upColor,
              borderColor0: downColor,
            },
            markPoint: {
              symbol: "rect",
              symbolSize: [-10, 0.5],
              symbolOffset: [5, 0],
              itemStyle: {
                color: "rgba(255,255,255,.87)",
              },
              label: {
                color: "rgba(255,255,255,.87)",
                offset: [10, 0],
                fontSize: 10,
                align: "left",
                formatter: function (params) {
                  return Number(params.value).toFixed(2);
                },
              },
              data: [
                {
                  name: "max",
                  type: "max",
                  valueDim: "highest",
                },
                {
                  name: "min",
                  type: "min",
                  valueDim: "lowest",
                },
              ],
            },
          },
        ];
      } else {
        this.dynamicItems = [
          {
            name: "日K",
            type: "line",
            data: [],
            symbol: "none", //去除圆点
            smooth: true,
            lineStyle: { normal: { opacity: 1, width: 1, color: "#DCDCDC" } },
            z: 5,
            areaStyle: {
              origin: 'start',
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  { offset: 0, color: '#ddd' },
                  { offset: 0.5, color: 'pink' },
                  { offset: 1, color: 'red' }
                ]),
              opacity: 0.5
            }
          },
        ];
      }
      this.draw();
      this.websock.onopen();
      this.getKlineHistory();
      this.getKline();
    },
    footTab(idx) {
      this.footIdx = idx;
      if (idx == 2) {
        this.getMessage();
      }
    },
    downTimes(cutTime) {
      var that = this;
      var t = cutTime;
      var n = document.getElementById("circle");
      var totalTimes = parseInt(Date.now() / 1000) + cutTime;
      that.syTimes = t;
      $('#times').html(t + ' ' + 'S');
      if (that.is_close) {
        clearInterval(that.timerTimes);
        that.timerTimes = null;
        clearInterval(that.orderTimes);
        that.orderTimes = null;
        return false;
      } else {
        that.timerTimes = setInterval(() => {
          var that = this;
          t = totalTimes - parseInt(Date.now() / 1000);
          that.syTimes = t;
          if (t <= 0) {
            that.is_close = true;
            $('#times').html('');
            clearInterval(that.timerTimes);
            that.timerTimes = null;
          } else {
            // t -= 1;
            $('#times').html(t + ' ' + 'S');
            let e = Math.floor(t / cutTime * 230);
            n.style.strokeDashoffset = e - 230;
          }
        }, 1000);
      }
    },
    goBack() {
      var leftIdx = this.leftIdx
      this.leftData.map((item, index) => {
        if (item.symbol == this.symbol) {
          leftIdx = index || 0;
        }
      })

      if (get_param('jy') == 1) {
        location.href = 'transaction.html?symbol=' + this.symbol + '&leftIdx=' + leftIdx + '&currency=' + this.currency
      } else if (get_param('jy') == 2) {
        location.href = 'leveragedDeals.html?symbol=' + this.symbol + '&leftIdx=' + leftIdx + '&currency=' + this.currency
      } else {
        location.href = 'transaction.html?symbol=' + this.symbol + '&leftIdx=' + leftIdx + '&currency=' + this.currency
      }
    }
  },
  sockets: {},
  filters: {
    fx(val) {
      if (val == 1) {
        return that.$t('jghy.mz')
      } else if (val == 2) {
        return that.$t('jghy.md')
      } else {
        return that.$t('jghy.mz')
      }
    },
    toFixed2: function (value) {
      if (!value) return;
      value = Number(value);
      return value.toFixed(2);
    },
    toFixed4: function (value, options) {
      if (!value) return;
      value = Number(value);
      return value.toFixed(4);
    },
    timeTamp: function (timestamp, options) {
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() > 9 ? date.getDate() + ' ' : ('0' + date.getDate()) + ' ';
      var h = date.getHours() > 9 ? date.getHours() + ':' : ('0' + date.getHours()) + ':';
      var m = date.getMinutes() > 9 ? date.getMinutes() + ':' : ('0' + date.getMinutes()) + ':';
      var s = date.getSeconds() > 9 ? date.getSeconds() : ('0' + date.getSeconds());
      return h + m + s;
    }
  },
  components: {
    navBar,
    loading,
    noData
  },
  computed: {
    listenState() { //监听交易对
      return this.symbol;
    }
  },
  watch: {
    newprice: {
      handler: function (val, oldValue) {
        var dataNow, option2;
        if (parseFloat(val) > 0) {
          if (this.klineDatas.length > 0) {
            dataNow = this.calculateMA(1, this.klineDatas);
            this.klineDatas[this.klineDatas.length - 1][1] = val;
          };
          if (this.currency != $('.kline-head .kline-left .t1').attr('data')) return false;
          option2 = {
            series: [
              {
                name: '日K',
                data: this.current === -1 ? dataNow : this.klineDatas,
              },
              {
                markLine: {//图表标线
                  label: {
                    position: 'middle'
                  },
                  formatter: val.toString(),
                  data: [
                    { yAxis: val.toString() }
                  ]
                },
              }
            ]
          }
          option2 && myChart.setOption(option2);
        }
      },
      deep: true,
      immediate: true
    },
    syTimes: function (val) {
      var that = this;
      if (val <= 0) {
        that.is_close = true;
        setTimeout(() => {
          that.getOrderDetail();
          that.getAsset();
          that.syTimes = 1;
          that.isJsDOwnTime = true;
        }, 1800)
      }
    }
  },
  beforeDestroy() {
    localStorage.removeItem('reloaded');
    clearInterval(this.timer);
    clearInterval(this.timerTimes);
    clearInterval(this.klineTimer)
    clearInterval(this.orderTimes);
    this.orderTimes = null;
    this.timer = null;
    this.timerTimes = null;
    this.klineTimer = null;
  },
  destroyed() {
    clearInterval(this.orderTimes);
    this.orderTimes = null;
  }
}
</script>
<style scoped>
.position-box {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  color: #cecece;
  font-size: .32rem;
  background: url('../assets/element-background.png') no-repeat center center;
  background-size: cover;
  overflow: hidden;
}

.head-tab-box {
  position: fixed;
  top: 0;
  width: 100%;
  padding: .24rem 0 .3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #131e30;
}

.head-tab-box .tab {
  padding: 0 .24rem;
  height: .75rem;
  color: #fff;
  font-size: .39rem;
  line-height: .75rem;
  background: #26384c;
  text-align: center;
}

.head-tab-box .tab.active {
  color: #fff;
  background: #218adc;
}

.head-tab-box .tab1 {
  border-radius: .6rem 0 0 .6rem;
}

.head-tab-box .tab2 {
  border-radius: 0 .6rem .6rem 0;
}

.scroll-box {
  position: absolute;
  left: -1px;
  right: 0;
  top: 1.2rem;
  bottom: 2.1rem;
  overflow-y: scroll;
}

.kline-head {
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 1.2rem;
  padding: 0 .42rem;
  color: #fff;
  font-size: .48rem;
  line-height: 1.2rem;
  box-sizing: border-box;
}

.kline-head .kline-left {
  display: flex;
  flex: 1;
  align-items: center;
}

.kline-head .back {
  width: .36rem;
  height: .6rem;
  margin-right: .3rem;
}

.kline-head .btn-back {
  width: .36rem;
  height: .6rem;
}

.kline-head .btn-alert {
  margin: 0 .54rem 0 0;
  width: .6rem;
  height: .6rem;
}

.kline-head .kline-right {
  display: flex;
  align-items: center;
}

.kline-head .kline-right .btn {
  width: .54rem;
  height: .54rem;
}

.kline-head .kline-right .btn-qp {
  margin-left: .54rem;
}

.info-box {
  position: relative;
  padding: .06rem .42rem;
}

.info-box .info-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-box .info-head .info-left .price {
  color: #00c483;
  font-size: .54rem;
  font-weight: bold;
}

.info-box .info-head .info-left .t1 {
  margin-top: .54rem;
  color: #7286a7;
  font-weight: bold;
}

.info-box .info-head .info-left .t1 span {
  margin-left: .3rem;
  color: #00c483;
  font-size: .36rem;
}

.info-box .info-head .info-right .item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2px;
  color: #7286a7;
  font-size: .36rem;
}

.info-box .info-head .info-right .num {
  margin-left: .3rem;
  color: #fff;
  font-size: .36rem;
}

.info-box .info-foot {
  position: absolute;
  width: 90%;
}

.info-box .item-box {
  position: relative;
  z-index: 97;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .1rem 0 .3rem;
  color: #7286a7;
  font-size: .36rem;
}

.info-box .item-box .item .icon {
  width: .75rem;
  height: .75rem;
}

.info-box .item-box .item.more {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-box .item-box .item .down {
  width: .3rem;
  height: .3rem;
}

.info-box .item-box .item {
  position: relative;
}

.info-box .item-box .item.active {
  color: #218adc;
}

.info-box .item-box .item.moreActive {
  color: #218adc;
}

.info-box .item-box .item.active::after {
  position: absolute;
  left: 0;
  bottom: -.18rem;
  content: '';
  width: 100%;
  height: 2px;
  border-radius: .3rem;
  background: #218adc;
}

.info-box .alert-sdt-box {
  position: absolute;
  left: .18rem;
  right: .18rem;
  top: 1.26rem;
  width: auto;
  padding: .42rem .48rem .42rem .36rem;
  border: 1px solid #4f4f4f;
  border-radius: .12rem;
  background: #131e30;
}

.info-box .alert-sdt-box .alert-sdt-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-box .alert-sdt-box .alert-sdt-list:last-child {
  margin-top: .42rem;
}

.info-box .alert-sdt-box .alert-sdt-list .text {
  padding-right: .42rem;
  color: #fff;
}

.info-box .alert-sdt-box .alert-sdt-info {
  display: flex;
  flex: 1;
  align-items: center;
  padding: 0 .3rem;
  border-left: 1px solid #526270;
}

.info-box .alert-sdt-box .alert-sdt-info .info-text {
  width: 1.35rem;
}

.info-box .alert-sdt-box .alert-sdt-info .active {
  color: #fff;
}

.info-box .alert-sdt-box .alert-sdt-list .icon {
  width: .66rem;
  height: .48rem;
}

.info-box .alert-sdt-box .alert-more-list {
  display: flex;
  align-items: center;
}

.info-box .alert-sdt-box .alert-more-list .text {
  flex: 1;
  border-right: 1px solid #7286a7;
  text-align: center;
}

.info-box .alert-sdt-box .alert-more-list .text:last-child {
  border-right: none;
}

.info-box .alert-sdt-box .alert-more-list .active {
  color: #fff;
}

.cont-box {
  padding: 0 .36rem 1.65rem;
  background: #131e30;
}

.cont-box .tab-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: .42rem 0 .54rem;
  color: #7286a7;
  font-size: .45rem;
}

.cont-box .tab-box .tab {
  position: relative;
  width: 33.33%;
  font-size: .36rem;
  text-align: center;
}

.cont-box .tab-box .tab.active {
  color: #588bf8;
  font-size: .45rem;
}

.cont-box .tab-box .tab.active::after {
  position: absolute;
  left: 50%;
  bottom: -.18rem;
  content: '';
  width: .6rem;
  height: 2px;
  margin-left: -.3rem;
  background: #218adc;
}

.cont-box .item0-box {
  padding: 0 0 .54rem;
  color: #3d536e;
}

.cont-box .item0-box .table-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .54rem;
  font-size: .4rem;
}

.cont-box .item0-box .ul-box {
  display: flex;
  align-items: stretch;
  overflow-x: auto;
  font-size: .4rem;
}

.cont-box .item0-box .ul-box .list {
  flex: 1;
  height: inherit !important;
}

.cont-box .item0-box .ul-box .list .ul {
  width: 100%;
  padding-right: 2px;
  box-sizing: border-box;
}

.cont-box .item0-box .ul-box .list .item {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cont-box .item0-box .w1 {
  width: .72rem;
}

.cont-box .item0-box .w2 {
  width: 2.4rem;
  text-align: center;
}

.cont-box .item0-box .w3 {
  width: 2.34rem;
  color: #00c483;
  padding-right: .3rem;
  text-align: right;
}

.cont-box .item0-box .scroll {
  position: absolute;
  right: 0;
  z-index: -1;
  width: 0%;
  height: .9rem;
  background: #132b36;
}

.cont-box .item0-box .scroll2 {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 0%;
  height: .9rem;
  background: #232435;
}

.cont-box .item0-box .w4 {
  width: 2.76rem;
  padding-left: .3rem;
  color: #d14b65;
}

.cont-box .item0-box .w5 {
  width: 2.4rem;
  text-align: center;
}

.cont-box .item0-box .w6 {
  text-align: right;
}

.cont-box .item0-box .w7 {
  width: 5.16rem;
  text-align: center;
}

.cont-box .item0-box .ul-box .list {
  display: flex;
  justify-content: space-between;
  width: 50%;
  height: .9rem;
  margin-bottom: .12rem;
  line-height: .9rem;
  color: #7286a7;
}

.cont-box .item1-box .table-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #7286a7;
}

.cont-box .item1-box .table-head .th,
.cont-box .item1-box .table-body .td {
  flex: 1;
}

.cont-box .item1-box .table-body {
  height: 9.6rem;
  overflow-y: auto;
}

.cont-box .item1-box .table-body .table-tr {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: .48rem;
  color: #e2e2e2;
  font-size: .4rem;
}

.cont-box .item1-box .table-body .mr {
  color: #00c483;
}

.cont-box .item1-box .table-body .mc {
  color: #d14b65;
}

.cont-box .item2-box .cont1 {
  padding: .48rem .42rem .48rem .36rem;
  color: #e2e2e2;
  border-bottom: 1px solid #313a47;
  background: #162335;
}

.cont-box .item2-box .ul-box {
  padding: .36rem .36rem .54rem;
  background: #162335;
}

.cont-box .item2-box .ul-box .list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .54rem;
  color: #fff;
}

.cont-box .item2-box .ul-box .list:last-child {
  margin-bottom: 0;
}

.cont-box .item2-box .ul-box .list .t1 {
  padding-right: .18rem;
  color: #7286a7;
}

.cont-box .item2-box .ul-box .list .t2 {
  flex: 1.5;
  word-break: break-word;
  text-align: right;
}

.cont-box .item2-box .ul-box .list .t2 a {
  color: #588bf8;
}

.kline-box {
  width: 100%;
  height: 12rem;
}

.btn-box {
  position: fixed;
  bottom: 2.1rem;
  z-index: 9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: .24rem .42rem;
  background: #18293e;
  box-sizing: border-box;
}

.btn-box .btn {
  flex: 1;
  height: 1.08rem;
  color: #fff;
  font-size: .36rem;
  border-radius: .12rem;
}

.btn-box .btn.btn-buy {
  background: #05c48e;
  /*00c483 */
}

.btn-box .btn.btn-sell {
  margin-left: .3rem;
  background: #df473d;
  /*#d14b65 */
}

.alert-wrap {
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  padding: 0 .3rem;
  box-sizing: border-box;
}

.alert-wrap .alert-box {
  position: relative;
  top: 50%;
  width: 100%;
  padding: 0 .3rem;
  border-radius: 6px;
  background: #0f1a2a;
  transform: translateY(-50%);
  box-sizing: border-box;
}

.alert-wrap .alert-box .alert-head {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .36rem 0 .3rem;
  border-bottom: 1px solid #313a47;
}

.alert-wrap .alert-box .alert-head .title {
  color: #fff;
  font-size: .42rem;
}

.alert-wrap .alert-box .alert-head .btn-close {
  width: .42rem;
  height: .42rem;
}

.alert-wrap .alert-box .order-head {
  justify-content: space-between;
  border-bottom: 1px solid #313a47;
}

.alert-wrap .alert-box .alert-head .close {
  position: absolute;
  top: 50%;
  right: .3rem;
  width: .42rem;
  height: .42rem;
  margin-top: -.21rem;
}

.alert-wrap .alert-box .order-item1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .4rem 0 .3rem;
}

.alert-wrap .alert-box .order-item1 .box-lt {
  display: flex;
  align-items: center;
}

.alert-wrap .alert-box .order-item1 .box-lt .icon {
  width: 1.22rem;
  margin-right: .35rem;
}

.alert-wrap .alert-box .order-item1 .t1 {
  color: #fff;
  font-size: .42rem;
}

.alert-wrap .alert-box .order-item1 .t2 {
  margin-top: .3rem;
  color: #fff;
  font-size: .42rem;
}

.alert-wrap .alert-box .order-item1 .time-box {
  display: flex;
  align-items: center;
}

.alert-wrap .alert-box .order-item1 .time-box .time-icon {
  width: .5rem;
  margin-right: .2rem;
}

.alert-wrap .alert-box .order-item1 .time-box .time {
  color: #fff;
  font-size: .42rem;
}

.alert-wrap .alert-box .order-item1 .box-rt .money {
  margin-top: .28rem;
  color: #fff;
  font-size: .42rem;
}

.alert-wrap .alert-box .circle-box {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.52rem;
  height: 2.52rem;
  margin: .24rem auto .42rem;
}

.alert-wrap .alert-box .circle-box .text {
  width: 80px;
  height: 80px;
  color: #4458ed;
  line-height: 80px;
  font-size: .42rem;
  text-align: center;
}

.alert-wrap .alert-box .circle {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 80px;
  height: 80px;
  transform: translate(-50%, -50%);
}

.alert-sec-circle {
  stroke-dashoffset: 0;
  stroke-dasharray: 720;
  transition: stroke-dashoffset 1s linear
}

.alert-wrap .alert-box .price-box {
  padding: 1.11rem 0 1.38rem;
  color: #00c488;
  text-align: center;
}

.alert-wrap .alert-box .price-box .num {
  font-size: .6rem;
}

.alert-wrap .item-box {
  padding: 0 20px;
}

.alert-wrap .item-box .item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #c3c3c3;
  font-size: .4rem;
  padding-bottom: .54rem;
}

.alert-wrap .item-box .item .t1 {
  color: #fff;
}

.alert-wrap .item-box .item .t2 {
  color: #fff;
}

.alert-wrap .item-box .item .price {
  color: #00c488;
}

.alert-wrap .alert-btn-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .3rem 0 .54rem;
}

.alert-wrap .alert-btn-box .btn {
  height: 1.02rem;
  color: #fff;
  border-radius: .12rem;
  text-align: center;
}

.alert-wrap .alert-btn-box .btn.close {
  width: 106px;
  margin-right: .3rem;
  background: #367d99;
}

.alert-wrap .alert-btn-box .btn.order {
  flex: 1;
  background: #4458ed;
}

.alert-wrap .alert-tips {
  padding: .3rem 0;
  color: #fff;
  font-size: .42rem;
}

.alert-wrap .order-item2 {
  display: flex;
  align-items: center;
}

.alert-wrap .order-item2 .time-box {
  display: flex;
  align-items: center;
  min-width: 3.45rem;
  padding: .22rem .38em .22rem .26rem;
  border-radius: .12rem;
  border: 1px solid #313a47;
  box-sizing: border-box;
}

.alert-wrap .order-item2 .time-box .icon {
  width: .58rem;
}

.alert-wrap .order-item2 .time-box .time {
  margin: 0 .26rem 0 .52rem;
  color: #fff;
  font-size: .42rem;
}

.alert-wrap .order-item2 .time-box .arrow {
  width: .4rem;
}

.alert-wrap .order-item2 .fx-box {
  display: flex;
  align-items: center;
  margin-left: .52rem;
}

.alert-wrap .order-item2 .fx-box .bg-box {
  position: relative;
}

.alert-wrap .order-item2 .fx-box .bg-icon {
  width: 2.2rem;
  height: 1.1rem;
}

.alert-wrap .order-item2 .fx-box .text {
  position: absolute;
  top: 50%;
  width: 2.2rem;
  color: #fff;
  font-size: .42rem;
  text-align: center;
  transform: translateY(-50%);
}

.alert-wrap .order-item2 .input-box {
  height: 1.1rem;
  margin-left: .52rem;
  padding: .22rem .38em .22rem .26rem;
  border-radius: .12rem;
  border: 1px solid #313a47;
  box-sizing: border-box;
}

.alert-wrap .order-item2 .input-box .input {
  width: 4rem;
  color: #c3c3c3;
  font-size: .42rem;
}

.alert-wrap .time-wrap {
  width: 100%;
  height: 2.82rem;
  overflow: hidden;
}

.alert-wrap .time-wrap .time-box {
  width: 100%;
  height: 2.82rem;
  white-space: nowrap;
  overflow-x: auto;
}

.alert-wrap .time-wrap .time-item {
  position: relative;
  display: inline-block;
  min-width: 2.82rem;
  height: 2.7rem;
  margin-right: .27rem;
  font-size: .39rem;
  border: 2px solid transparent;
  border-radius: .18rem;
  background: #30385d;
  text-align: center;
}

.alert-wrap .time-wrap .time-item.active {
  border: 2px solid #4458ed;
}

.alert-wrap .time-wrap .time-item .icon {
  position: absolute;
  right: -2px;
  top: -2px;
  width: .84rem;
  height: .78rem;
}

.alert-wrap .time-wrap .time-item .t1 {
  padding: .36rem .12rem .27rem;
  color: #8e8e8e;
}

.alert-wrap .time-wrap .time-item .time {
  color: #4458ed;
}

.alert-wrap .time-wrap .time-item .num {
  font-size: .48rem;
}

.alert-wrap .time-wrap .time-item .t2 {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: .15rem 0;
  color: #db4949;
  border-radius: 0 0 .18rem .18rem;
  background: rgba(0, 0, 0, .5);
}

.alert-wrap .ky-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: .36rem 0;
  color: #c3c3c3;
}

.alert-wrap .ky-box .text {
  display: flex;
  align-items: center;
}

.alert-wrap .ky-box .text .icon {
  width: .6rem;
  height: .6rem;
}

.alert-wrap .trade-wrap {
  padding: .6rem 0;
}

.alert-wrap .trade-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: .4rem;
}

.alert-wrap .trade-box .text {
  width: 33.33%;
  color: #fff;
}

.alert-wrap .trade-item {
  padding-top: .42rem;
}

.alert-wrap .trade-item .t1 {
  color: #fff;
}

.alert-wrap .trade-item .t2 {
  color: #00c483;
}

.alert-wrap .trade-item .t2.active {
  color: #d14b65;
}

.alert-wrap .trade-item .t3 {
  color: #fff;
}

.alert-wrap .trade-item .icon {
  width: .6rem;
  height: .6rem;
  margin-left: .2rem;
  vertical-align: bottom;
}

.alert-time-box {
  position: absolute;
  bottom: 0;
  z-index: 1000;
  width: 100%;
  background: #0f1a2a;
}

.alert-time-box .alert-item {
  width: 100%;
  height: 1.44rem;
  color: #fff;
  line-height: 1.44rem;
  background: #0f1a2a;
  text-align: center;
}

.alert-time-box .alert-item {
  border-bottom: 1px solid #313a47;
}

.alert-time-box .alert-item.active {
  color: #218adc;
}

.alert-box .btn-cancle {
  margin-top: .18rem;
  border-bottom: none;
}
</style>
<style>
.charts-tooltip-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
}

.scroll-box.mn {
  top: 3.82rem;
}

.scroll-box.mn .kline-head {
  top: 2.4rem
}
</style>



// WEBPACK FOOTER //
// src/pages/contractTransaction.vue